module.exports = __webpack_public_path__ + "img/card-3.cd36ed7a.jpg";